import React from "react";
import "sass/components/layout/Footer.scss";

const Footer = () => {
  return (
    <footer className="footer-container">
      <p>© 2024 Lingple. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
